import React, { useState } from 'react';
import { Form, Radio, Spin } from 'antd';
import { ClubUser } from '../../../../models/clubUser';
import { useUserStore } from '../../../../store/useUser';
import { useNavigate } from 'react-router-dom';
import FormItem from 'antd/lib/form/FormItem';

import Button from '../../../../components/Button/Button';
import { useModal, UseModalStore } from '../../../../store/useModal';
import { useSidebarStore } from '../../../../store/useSidebar';
import SelectClub from '../../SelectClub/SelectClub';
import Modal from '../../../../components/Modal/Modal';

import styles from './SelectClubProfile.module.scss';

interface Props {
  clubs: ClubUser[]
}

const SelectClubProfile = ({ clubs }: Props) => {
  const [form] = Form.useForm();

  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(false);

  const userId = useUserStore(state => state.id)
  const setProfile = useUserStore(state => state.setProfile)
  const profile = useUserStore(state => state.profile)
  const closeModal = useModal((state: UseModalStore) => state.closeModal);
  const setMenu = useSidebarStore(state => state.setMenu)


  function filterRoles(clubs: ClubUser[]): Array<'Clubista' | 'Criador' | 'Mediador'>{
    if (!clubs.length) return []

    const profile: Array<'Clubista' | 'Criador' | 'Mediador'> = ['Clubista']

    for(let club of clubs){
      if (profile.length > 2) { break; }
      if(!!club.isCreator && !profile.includes('Criador')) profile.push('Criador')
      if(!!club.isMediator && !profile.includes('Mediador')) profile.push('Mediador')
    }

    return profile
  }

  const select = () => {
    const values = form.getFieldsValue()

    if(!clubs.length) return;
    if(!values) return;

    setProfile(values.profile);
    
    if(values.profile === 'Clubista'){
      setMenu();
      closeModal()
      navigate(`/user/${userId}`, { replace: true });
      return false
    }

    // Escolheu ser gerenciador
    return true
  }

  return (
    <div>
      <Form 
        layout="vertical"
        form={form}>
        <h1>Como gostaria de entrar?</h1>
        <br/>
        <FormItem name="profile" className={styles.items}>
          <Radio.Group style={{width: '100%'}}>
            {
              clubs && filterRoles(clubs).map((value, index: number) => {
                return (
                  <Radio 
                    className={styles.radio} 
                    key={index} 
                    value={value}
                    >
                      <h1>{value}</h1>
                  </Radio>
                );
              })
            }
          </Radio.Group>
        </FormItem>
        {!clubs && (
          <div className={styles.spinnerContainer}>
            <Spin className={styles.spinner} spinning={true} />
          </div>
        )}

        <Modal
          renderToggle={({ setOpen }) => {
            return (
              <Button
                submit
                loading={isLoading}
                disabled={isLoading}
                style={styles.loginButton}
                onClick={async () => {
                  if (select()) {
                    setOpen(true)
                  }
                }}
              >
                Confirmar
              </Button>
            )
          }}
        >
          {() => <SelectClub clubs={clubs} />}
        </Modal>
      </Form>
    </div>
  )
}

export default SelectClubProfile;